module.exports = __webpack_public_path__ + "img/logo.ba0e08cc.svg";